var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MemberUnit"}},[_c('Table',{attrs:{"show-header":false,"columns":_vm.columns,"data":_vm.list,"no-data-text":"暂无筛选结果"},on:{"on-row-click":_vm.onClickMemberUnit},scopedSlots:_vm._u([{key:"logo",fn:function(ref){
var row = ref.row;
return [_c('img',{staticStyle:{"width":"80px","height":"80px","margin":"5px"},attrs:{"src":row.logo}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }